module.exports = __webpack_public_path__ + "img/tarifas.fc9267d0.svg";